// src/slices/writer/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAllWriters, getOneWriter } from "./thunk";

const initialState = { list: [], singleWriter: null, loading: false, error: null };

const writerSlice = createSlice({
  name: "writer",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // GET ALL
      .addCase(getAllWriters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllWriters.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload?.data || action.payload;
      })
      .addCase(getAllWriters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET ONE
      .addCase(getOneWriter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOneWriter.fulfilled, (state, action) => {
        state.loading = false;
        state.singleWriter = action.payload?.data || action.payload;
      })
      .addCase(getOneWriter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default writerSlice.reducer;
